// https://stackoverflow.com/questions/57807248/vuecli3-app-nginx-docker-use-environment-specific-variables
// https://ledermann.dev/blog/2018/04/27/dockerize-and-configure-javascript-single-page-application/
/* eslint-disable no-bitwise */
/* eslint-disable no-console */
import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js'; // npm install --save crypto-js

const FLAG_DATAGOBLINS_AWS = 0x01;

export default class Configuration {
  static FLAG_DATAGOBLINS_AWS = FLAG_DATAGOBLINS_AWS;
  static FLAG_PRODUCT_KEY_MENU = FLAG_DATAGOBLINS_AWS << 1;
  static FLAG_TASK_HISTORY_DETAIL = FLAG_DATAGOBLINS_AWS << 2;
  static FLAG_ON_PREMISE = FLAG_DATAGOBLINS_AWS << 3;
  static FLAG_RESERVED = FLAG_DATAGOBLINS_AWS << 4;

  static get CONFIG() {
    return {
      GPROJECT_ADDRESS: '$VUE_APP_GPROJECT_ADDRESS',
      GUNIT_ADDRESS: '$VUE_APP_GUNIT_ADDRESS',
      GACCOUNT_ADDRESS: '$VUE_APP_GACCOUNT_ADDRESS',
      GSTAT_ADDRESS: '$VUE_APP_GSTAT_ADDRESS',
      GREWARD_ADDRESS: '$VUE_APP_GREWARD_ADDRESS',
      GPREPROC_ADDRESS: '$VUE_APP_GPREPROC_ADDRESS',
      GPOSTPROC_ADDRESS: '$VUE_APP_GPOSTPROC_ADDRESS',
      GCERT_ADDRESS: '$VUE_APP_GCERT_ADDRESS',
      GPUSH_ADDRESS: '$VUE_APP_GPUSH_ADDRESS',
      GPROC_ADDRESS: '$VUE_APP_GPROC_ADDRESS',
      STTSERVER_ADDRESS: '$VUE_APP_STTSERVER_ADDRESS',
      GKEYGEN_ADDRESS: '$VUE_APP_GKEYGEN_ADDRESS',
      RSA_PUB_KEY: '$VUE_APP_RSA_PUB_KEY',
      LICENSE_PUBLIC_KEY: '$VUE_APP_LICENSE_PUBLIC_KEY',
      LICENSE_ID: '$VUE_APP_LICENSE_ID',
      LICENSE_KEY: '$VUE_APP_LICENSE_KEY',
    };
  }

  static value(key) {
    if (!(key in this.CONFIG)) {
      console.log(`Configuration: There is no key named "${key}"`);
      return null;
    }

    const value = this.CONFIG[key];

    if (!value) {
      console.log(`Configuration: Value for "${key}" is not defined`);
      return null;
    }

    if (!value.startsWith('$VUE_APP_')) {
      // value was already replaced, it seems we are in production (containerized).
      return value;
    }

    // value was not replaced, it seems we are in development.
    // Remove $ and get current value from process.env
    const envName = value.substr(1);
    const envValue = process.env[envName];
    if (!envValue) {
      console.error(`Configuration: Environment variable "${envName}" is not defined`);
      return null;
    }

    return envValue;
  }

  static valueBool(key) {
    const value = Configuration.value(key);
    if (value === null) {
      return false;
    }

    if (value.toLowerCase() === 'true') {
      return true;
    }

    return false;
  }

  static LicenseHasFlag(flag) {
    let id = this.value('LICENSE_ID');
    const key = this.value('LICENSE_KEY');
    const publicKey = this.value('LICENSE_PUBLIC_KEY');
    if (id === null || key === null || publicKey === null
      || id.length === 0 || key.length === 0 || publicKey.length === 0
      || id === 'TODO' || key === 'TODO' || publicKey === 'TODO') {
      throw new Error('no license');
    }

    id = atob(id);

    // Verify with the public key...
    const verify = new JSEncrypt();
    verify.setPublicKey(publicKey);
    const verified = verify.verify(id, key, CryptoJS.SHA256);
    if (!verified) {
      throw new Error('invalid license');
    }

    const list = id.split(',');
    if (list.length < 4) {
      throw new Error('invalid license format');
    }

    const version = parseInt(list[0], 10);
    // const email = list[1];
    // const expiration = list[2];
    const scope = parseInt(list[3], 10);

    if (version === 1 && list.length !== 4) {
      throw new Error('invalid license format');
    }
    if (scope & flag) {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/js/Configuration.js